import storage from "~/assets/js/Storage";

export default {
  request({ commit }) {
    let restaurantId = this.$localStore.get("activeRestaurantId");
    let menuId = this.$localStore.get("activeMenuId");

    this.$axios
      .get(
        `${this.$config.apiUrl}${this.$config.endpoints.analysis.get}?restaurant_id=${restaurantId}&menu_id=${menuId}`,
        {
          headers: {
            Authorization: "Bearer " + this.$localStore.get("accessToken"),
          },
        }
      )
      .then((response) => {
        // save analysis in storage
        storage.putAnalysis(response.data);

        // init vuex
        commit("init", response.data);

        // redirect to analysis page
        this.$router.push("/pianifica/analisi");
      })
      .catch((err) => {
        console.log(err);
        // Todo: display error or something
      });
  },
  requestPartial({ commit }) {
    let menuId = this.$localStore.get("activeMenuId");
    this.$axios
      .get(
        `${this.$config.apiUrl}${this.$config.endpoints.analysis.menu}?&menu_id=${menuId}`,
        {
          headers: {
            Authorization: "Bearer " + this.$localStore.get("accessToken"),
          },
        }
      )
      .then((response) => {
        // save analysis in storage

        const manually_formatted_analisys_cuz_batto1300_cant_return_a_consistent_data_format =
          {
            menu_id: menuId,
            grafici: {
              efficienza_menu: [...response.data.menu_efficiency],
            },
            costo_cliente_unico: response.data.cost,
            ricavo_cliente_unico: response.data.price
          };

        storage.putPartialAnalysis(
          manually_formatted_analisys_cuz_batto1300_cant_return_a_consistent_data_format
        );

        // init vuex
        commit(
          "init",
          manually_formatted_analisys_cuz_batto1300_cant_return_a_consistent_data_format
        );

        // redirect to analysis page
        this.$router.push("/analisi-menu/analisi");
      })
      .catch((err) => {
        console.log(err);
        // Todo: display error or something
      });
  },
};
